import styled from 'styled-components';

export const StyledFeeSection = styled.div`
  border-radius: ${({ theme }) => theme.spacing.spacing4};
  border: 1px solid ${({ theme }) => theme.colors.gray};
`;
export const StyledFeeSectionHeader = styled.div`
  padding: ${(props) => props.theme.spacing.roomyContentPaddingValue}px;
  display: grid;
  grid-template-columns: auto min-content min-content;
  gap: ${({ theme }) => theme.spacing.spacing8};
  align-items: center;
`;
